import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function MediaLibrary({ onSelect, onClose }) {
  const [images, setImages] = useState([]);
  const [filteredImages, setFilteredImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  // Stan paginacji
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20; // Ilość zdjęć na stronę

  useEffect(() => {
    axios.get('https://megamont.pl/api/all-images')
      .then(res => {
        // Sortujemy od najnowszych (zakładając, że nowsze mają wyższe ID/datę w nazwie)
        const sorted = res.data.reverse(); 
        setImages(sorted);
        setFilteredImages(sorted);
        setLoading(false);
      })
      .catch(err => console.error("Błąd ładowania galerii", err));
  }, []);

  // Filtrowanie zdjęć przy zmianie wyszukiwania
  useEffect(() => {
    const filtered = images.filter(img => 
      img.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredImages(filtered);
    setCurrentPage(1); // Resetuj do 1 strony przy szukaniu
  }, [searchTerm, images]);

  // Obliczanie indeksów dla aktualnej strony
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredImages.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredImages.length / itemsPerPage);

  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 1060 }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable shadow-lg">
        <div className="modal-content border-0">
          <div className="modal-header bg-dark text-white">
            <h5 className="modal-title">Biblioteka Mediów</h5>
            <input 
              type="text" 
              className="form-control form-control-sm ms-4 w-50" 
              placeholder="Szukaj zdjęcia..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>

          <div className="modal-body bg-light">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status"></div>
                <p className="mt-2">Pobieranie listy plików...</p>
              </div>
            ) : (
              <>
                <div className="row g-2">
                  {currentItems.map((img, idx) => (
                    <div className="col-6 col-md-3 mb-2" key={idx}>
                      <div 
                        className="card h-100 border-0 shadow-sm p-1 gallery-item" 
                        onClick={() => onSelect(img)}
                        style={{ cursor: 'pointer' }}
                      >
                        <img 
                          src={`https://megamont.pl/uploads/${img}`} 
                          className="card-img-top rounded" 
                          style={{ height: '120px', objectFit: 'cover' }}
                          alt="preview"
                        />
                        <div className="p-1">
                           <p className="small text-truncate m-0 text-muted" style={{ fontSize: '10px' }}>
                             {img.split('/').pop()}
                           </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {filteredImages.length === 0 && (
                  <div className="text-center py-5">Brak zdjęć pasujących do filtrów.</div>
                )}
              </>
            )}
          </div>

          {/* STOPKA Z PAGINACJĄ */}
          {!loading && totalPages > 1 && (
            <div className="modal-footer justify-content-between bg-white">
              <span className="small text-muted">
                Zdjęcia {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, filteredImages.length)} z {filteredImages.length}
              </span>
              <nav>
                <ul className="pagination pagination-sm m-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>Poprzednia</button>
                  </li>
                  
                  {[...Array(totalPages)].map((_, i) => {
                    // Wyświetlaj tylko kilka stron wokół obecnej, żeby nie było 100 przycisków
                    if (i + 1 === 1 || i + 1 === totalPages || (i + 1 >= currentPage - 2 && i + 1 <= currentPage + 2)) {
                      return (
                        <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                          <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                        </li>
                      );
                    }
                    return null;
                  })}

                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>Następna</button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </div>
      <style>{`
        .gallery-item:hover {
          transform: translateY(-3px);
          transition: 0.2s;
          box-shadow: 0 4px 8px rgba(0,0,0,0.2) !important;
        }
        .gallery-item:hover img {
          filter: brightness(0.8);
        }
      `}</style>
    </div>
  );
}